/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import {reorderContents, selectContent, invalidateSelectedContent, updateNoLiveContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import ContentSelector from 'pages/dashboard/embeds/management/customize/contentselector/contentselector';



/* ========== ~~~~~~~~~~ EMBED CONTENT SELECTOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        contents: embedsState.embedManagementState.contentStatus.contents,
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
        noLiveContents: contentStatus.noLiveContents
    }
};

const mapDispatchToProps = dispatch => ({
    selectContent: contentId => dispatch(selectContent(contentId)),
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message)),
    reorderContents: (liveContents, inactiveContents) => dispatch(reorderContents(liveContents, inactiveContents)),
    updateNoLiveContent: bool => dispatch(updateNoLiveContent(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentSelector);
